// extracted by mini-css-extract-plugin
export default {"daterName":"OthersFriendList_daterName__cd+tj","logo":"OthersFriendList_logo__cuV-V"};